import moment from "moment";
import { useTranslation } from "react-i18next";
import InfinityTable from "../../../components/infinity-table/infinity-table";
import { useState, useEffect } from "react";

const CohortTable = ({
  data,
  onHandleRowClick,
  selectionColumn,
  containerRef,
  after,
}) => {
  const { t } = useTranslation();
  const [sortedData, setSortedData] = useState(data);
  const [sortInfo, setSortInfo] = useState({});

  useEffect(() => {
    setSortedData(data);
  }, [data]);

  const handleTableChange = (_pagination, _filters, sorter) => {
    if (!sorter.order) {
      setSortedData(data);
      setSortInfo({});
      return;
    }

    const sorted = [...data].sort((a, b) => {
      const aVal = a[sorter.field];
      const bVal = b[sorter.field];

      if (sorter.field === "updatedAt") {
        return sorter.order === "ascend"
          ? new Date(aVal) - new Date(bVal)
          : new Date(bVal) - new Date(aVal);
      }

      if (typeof aVal === "string") {
        return sorter.order === "ascend"
          ? aVal.localeCompare(bVal)
          : bVal.localeCompare(aVal);
      }

      return 0;
    });

    setSortedData(sorted);
    setSortInfo(sorter);
  };

  const columns = [
    {
      title: t("administration.cohort.table.name"),
      dataIndex: "value",
      render: (_, cohort) => <span>{cohort.value || "N/A"}</span>,
      key: "value",
      width: "30%",
      sortOrder: sortInfo.field === "value" ? sortInfo.order : null,
      sorter: true,
    },
    {
      title: t("administration.cohort.table.last_modified"),
      dataIndex: "updatedAt",
      render: (_, cohort) => (
        <span>
          {`${moment(cohort.updatedAt).utc().format("DD MMM YYYY, HH:mm")}, UTC`}
        </span>
      ),
      key: "updatedAt",
      width: "30%",
      sortOrder: sortInfo.field === "updatedAt" ? sortInfo.order : null,
      sorter: true,
    },
  ];

  const tableColumns = selectionColumn ? [selectionColumn, ...columns] : columns;

  return (
    <InfinityTable
      data={sortedData}
      fetchData={() => console.log("fetchData")}
      hasMore={false}
      tableColumns={tableColumns}
      isLoading={false}
      onHandleRowClick={onHandleRowClick}
      onChange={handleTableChange}
      containerRef={containerRef}
      after={after}
    />
  );
};

export default CohortTable;